import { themes } from 'kb-shared';
import styled from 'styled-components';

export const HeartsIconContainer = styled.div`
  margin-top: -15px;
  margin-left: -10px;
  width: 62px;
  height: 53px;
  position: absolute;

  svg {
    width: 100%;
    height: 100%;
  }

  @media screen and ${themes.queries.mobile} {
    display: none;
  }
`;

export const IntercourseReminderContainer = styled.div`
  border-radius: 16px;
  background: ${themes.colors.white};
  box-shadow: ${themes.shadows.card.level2};
  padding: 1em 3em 1.5em 3em;
  margin-top: 3em;
  @media screen and ${themes.queries.mobile} {
    padding: 4em 1.5em;
    margin-top: 2em;
    border-bottom: ${themes.colors.semantic.red};
    background: ${themes.colors.semantic.lightPink};
    border-radius: 0;
    box-shadow: none;
    background-image: url("data:image/svg+xml,%3Csvg width='320' height='229' viewBox='0 0 320 229' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3EHearts%3C/title%3E%3Cpath opacity='0.24' d='M-38.9615 134.921L-39.4354 133.152C-46.0701 108.391 -34.0705 82.4281 -10.7058 71.9971C4.45378 64.9021 22.5008 65.7533 37.3017 74.2986L42.589 77.0522L45.4374 72.1186C53.9827 57.3178 69.1863 47.5571 85.8624 46.1217C111.312 43.4728 135.039 59.8628 141.674 84.6238L142.148 86.3925C146.129 101.249 143.553 117.104 135.595 129.852L87.588 206.788C85.7754 209.928 82.5224 211.937 78.9851 212.884C75.0941 213.927 71.2725 213.814 68.1329 212.001L-11.9102 169.376C-25.176 162.315 -34.9807 149.777 -38.9615 134.921Z' fill='%23DB685D'/%3E%3Cg opacity='0.48'%3E%3Cpath d='M235.125 35.7576L235.345 35.1546C238.418 26.7124 247.081 21.6709 255.886 23.3731C261.664 24.3836 266.674 28.2558 269.206 33.6843L270.17 35.5377L271.98 34.6939C277.408 32.1626 283.735 32.4166 288.811 35.3568C296.65 39.7123 300.167 49.1872 297.094 57.6295L296.874 58.2325C295.031 63.2979 291.104 67.3319 286.257 69.3919L257.009 81.8287C255.858 82.3657 254.52 82.2885 253.314 81.8496C251.987 81.3667 250.913 80.5659 250.376 79.4144L235.965 51.0872C233.576 46.3934 233.282 40.823 235.125 35.7576Z' fill='%23DB685D'/%3E%3Cpath d='M238.316 61.7524L238.834 62.3172L239.399 61.7995C240.952 60.2465 243.164 59.5407 245.281 59.9171C248.528 60.4348 250.928 63.2584 250.928 66.5525V66.7878C250.928 68.7643 250.081 70.6467 248.67 71.9643L240.152 79.9174C239.822 80.2468 239.352 80.388 238.881 80.388C238.364 80.388 237.893 80.2468 237.564 79.9174L229.046 71.9643C227.634 70.6467 226.834 68.7643 226.834 66.7878V66.5525C226.834 63.2584 229.187 60.4348 232.434 59.9171C234.552 59.5407 236.764 60.2465 238.316 61.7524C238.316 61.7995 238.269 61.7524 238.316 61.7524ZM238.834 65.5172L236.716 63.3525C235.681 62.3642 234.222 61.8936 232.811 62.1289C230.646 62.5054 229.093 64.3407 229.093 66.5525V66.7878C229.093 68.1525 229.61 69.4231 230.599 70.3173L238.881 78.035L247.117 70.3173C248.105 69.4231 248.67 68.1525 248.67 66.7878V66.5525C248.67 64.3407 247.07 62.5054 244.905 62.1289C243.493 61.8936 242.034 62.3642 240.999 63.3525L238.834 65.5172Z' fill='white'/%3E%3Cpath d='M238.835 65.5183L236.717 63.3536C235.682 62.3653 234.223 61.8947 232.811 62.13C230.647 62.5065 229.094 64.3418 229.094 66.5536V66.7889C229.094 68.1536 229.611 69.4243 230.6 70.3184L238.882 78.0361L247.118 70.3184C248.106 69.4243 248.67 68.1536 248.67 66.7889V66.5536C248.67 64.3418 247.07 62.5065 244.906 62.13C243.494 61.8947 242.035 62.3653 241 63.3536L238.835 65.5183Z' fill='%23DB685D'/%3E%3Cpath d='M295.02 54.3399L295.186 55.0878L295.933 54.9219C298.055 54.3534 300.323 54.848 301.969 56.2329C304.522 58.3047 305.189 61.95 303.542 64.8029L303.424 65.0066C302.436 66.7183 300.761 67.925 298.88 68.3602L287.527 70.9889C287.077 71.1095 286.598 70.9964 286.191 70.7611C285.743 70.5023 285.406 70.1447 285.285 69.6947L281.885 58.5483C281.321 56.7013 281.57 54.6711 282.558 52.9594L282.675 52.7556C284.322 49.9028 287.772 48.634 290.843 49.8093C292.865 50.5421 294.428 52.2593 295.02 54.3399C294.996 54.3807 294.979 54.3164 295.02 54.3399ZM293.585 57.8591L292.834 54.9256C292.431 53.5521 291.403 52.4151 290.063 51.913C288 51.1567 285.738 51.9696 284.632 53.8851L284.514 54.0888C283.832 55.2707 283.645 56.6299 284.053 57.8984L287.367 68.7234L298.358 66.1573C299.661 65.8771 300.786 65.0591 301.468 63.8772L301.586 63.6734C302.691 61.758 302.223 59.3685 300.537 57.9601C299.432 57.0505 297.933 56.7286 296.543 57.0668L293.585 57.8591Z' fill='white'/%3E%3Cpath d='M293.587 57.8596L292.836 54.9261C292.433 53.5526 291.405 52.4156 290.065 51.9135C288.002 51.1572 285.739 51.9701 284.633 53.8856L284.516 54.0894C283.833 55.2713 283.646 56.6305 284.055 57.8989L287.369 68.7239L298.36 66.1578C299.663 65.8776 300.787 65.0596 301.47 63.8777L301.587 63.674C302.693 61.7585 302.225 59.369 300.539 57.9606C299.434 57.051 297.935 56.7291 296.544 57.0673L293.587 57.8596Z' fill='%23DB685D'/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: top 10px left;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  @media screen and ${themes.queries.minLargeDesktop} {
    flex-direction: row;
  }
  @media screen and ${themes.queries.minLargeDesktop} {
    > button {
      margin-top: 1em;
      width: 100%;
    }
  }
`;

export const SimpleFlex = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and ${themes.queries.minLargeDesktop} {
    text-align: center;
    align-items: center;
  }
`;

export const Container = styled.div`
  padding: 0;

  @media ${({ theme }) => theme.queries.tablet} {
    padding: 0 24px;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    padding: 0;
  }
`;
